// extracted by mini-css-extract-plugin
export var label = "_l3-2";
export var slideContainer = "_l3-0";
export var slider = "_l3-1";